import { render, staticRenderFns } from "./OfflineClassesDetail.vue?vue&type=template&id=73557ecc&"
import script from "./OfflineClassesDetail.vue?vue&type=script&lang=js&"
export * from "./OfflineClassesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports